import { Validators } from '@angular/forms';
import { Form } from 'app/components/form/form';

export class ChangePasswordForm extends Form {

  formErrors = {
    'newPassword': {
      valid: true
    },
    'confirmNewPassword': {
      valid: true
    },
  };

  getInitForm = (password?: string, confirmPassword?: string) => {
    return {
      'newPassword': [password, [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(16),
        this.validateInvalidCharacter(this.validatePattern.password)
      ]],
      'confirmNewPassword': [confirmPassword, [
        Validators.required
      ]]
    };
  };
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-change-password/change-password.form.ts